<template>
 <div>
        <div>
            <div>
                <div class="questionNums"><span>{{examIndex+1}}</span>/ 共{{questionNum}}题</div>
                	<div>
			</div>
            </div>
			
           <div>
                <div v-show="examIndex === index ? true :false"  class="option-div" v-for="(questionsItem,index) in wrongQuestionLists" :key="index">
                    <h2 v-if="questionsItem.type == '001001'" class="questionTitle" ><span>「单选」</span>{{questionsItem.content}}</h2>
                    <h2 v-if="questionsItem.type == '001002'" class="questionTitle" ><span>「多选」</span>{{questionsItem.content}}</h2>
                    <h2 v-if="questionsItem.type == '001003'" class="questionTitle" ><span>「判断」</span>{{questionsItem.content}}</h2>
                    <div class="option-list-radio  cb" v-for="(choicesItem,index) in questionsItem.choices" :key="index">
                        <div v-if="questionsItem.type == '001001'" style="display: flex;align-items: center;">
                        <!-- <el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code" @change="radioChange">
                            <span >{{choicesItem.code}}</span>
                        </el-radio> -->
                            <van-radio v-model="questionsItem.userAnswer" @click="radioChange" :name="choicesItem.code">{{choicesItem.code}}.</van-radio>
                        <div>
                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                        </div>
                        </div>
                         <div v-if="questionsItem.type == '001002'" style="display: flex;align-items: center;">
                        <van-checkbox-group v-model="questionsItem.userAnswer">
                            <van-checkbox @click="radioChange" :name="choicesItem.code">{{choicesItem.code}}.</van-checkbox>
                        </van-checkbox-group>
                        <div>
                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                        </div>
                        </div>
                         <div v-if="questionsItem.type == '001003'" style="display: flex;align-items: center;">
                            <van-radio v-model="questionsItem.userAnswer" @click="radioChange" :name="choicesItem.code">{{choicesItem.code}}.</van-radio>
                        <div>
                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                        </div>
                        </div>
                    </div>
                    <div>
                    <!-- 正确答案 -->
                    <div class="rightKey"><span>正确答案{{questionsItem.answer}}</span></div>
                    <!-- 本题解析 -->
                    <div @click="log()" class="analysis">「本题解析」
                        <div class="personalAnalysis" v-html="questionsItem.analysis"></div>
                    </div>
                    </div>
                </div>
            </div>
		</div>
	 <div>
  <van-cell v-if="!show"  class="examFooters">
                <!-- <a javascript: style="color: #2E56D5;" @click="submitExam()">交卷</a> -->
                <van-button class="questionbtn"  @click="lastQuestion"  plain type="danger">上一题</van-button>
                <van-button class="questionbtn" @click="nextQuestion" plain type="danger">下一题</van-button>
                <a javascript: @click="showPopup"><img src="../../../static/images/mobile/answerSheet.png" alt=""> {{examIndex+1}}/{{questionNum}}</a>
            </van-cell>
			<van-popup   v-model="show"  :overlay="false" position="bottom"  >
                <van-cell class="examFooter">
                <!-- <a javascript: style="color: #2E56D5;" @click="submitExam()">交卷</a> -->
                <van-button class="questionbtn"  @click="lastQuestion"  plain type="danger">上一题</van-button>
                <van-button class="questionbtn" @click="nextQuestion" plain type="danger">下一题</van-button>
                <a javascript: @click="showPopup"><img src="../../../static/images/mobile/answerSheet.png" alt=""> {{examIndex+1}}/{{questionNum}}</a>
            </van-cell>
                <van-button :class="[index === examIndex ? 'active1' : '',{unanswered: typeof(item.userAnswer)!='undefined' && item.userAnswer.length!=0
}]" class="questionAnswer" @click="selecteQuestion(index)" v-for="(item,index) in wrongQuestionLists" :key="index" plain type="danger">{{index+1}}</van-button>
            </van-popup>
            </div>
	</div>
	
</template>
<style scoped>
.rightKey {
  border-radius: 0.106667rem;
  background: #efefef;
  height: 1.066667rem;
  width: 9.146667rem;
  line-height: 1.066667rem;
  margin: 0 auto;
}
.rightKey span {
  margin-left: 0.426667rem;
}
.analysis {
  margin-left: 0.426667rem;
  margin-top: 0.64rem;
  font-weight: 400;
  font-size: 0.426667rem;
}
.personalAnalysis {
  padding-top: 0.426667rem;
}
.option-div {
  display: flex;
  flex-direction: column;
}
.questionNums {
  margin-top: 0.693333rem;
  margin-left: 0.426667rem;
}
.questionNums span {
  width: 0.533333rem;
  border-bottom: 0.106667rem #dc0021 solid;
}
.block {
  color: #dc0021;
}
.van-count-down {
  margin-top: 0.693333rem;
  margin-right: 0.426667rem;
  color: #dc0021;
  font-size: 0.373333rem;
}
.examFooter {
  /* 方法一 */
  position: fixed;
  bottom: 0;
  border: 1px solid #dfdede;
}
.exam-words {
  font-weight: 600;
  font-size: 0.373333rem;
  color: #000000;
}
.van-popup {
  border: 1px solid #dfdede;
}
.van-popup .van-button {
  border-radius: 50%;
  height: 0.96rem;
  width: 0.96rem;
  margin: 0.6rem 0 0.6rem 0.6rem;
}
.van-cell__value {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.questionbtn {
  border-radius: 0.426667rem !important;
  height: 0.853333rem !important;
  width: 2.346667rem !important;
}
.examFooter a img {
  width: 0.426667rem;
  height: 0.426667rem;
}
.active1 {
  border: 1px red solid !important;
}
.examFooters {
  /* 方法一 */
  position: fixed;
  bottom: 0;
  border: 1px solid #dfdede;
}
.examFooters a img {
  width: 0.426667rem;
  height: 0.426667rem;
}
.examFooters .questionbtn {
  border-radius: 0.426667rem;
  height: 0.853333rem;
  width: 2.346667rem;
}
.questionTitle {
  color: #000000;
  font-size: 0.426667rem;
  font-weight: 400;
  margin: 0.506667rem 0.426667rem 0.64rem 0.426667rem;
}
.questionTitle span {
  color: #2e56d5;
}
.option-list-radio {
  margin-left: 0.426667rem;
  margin-bottom: 0.64rem;
}
.questionAnswer {
  color: #000000;
  background: #f3f3f5;
  border: none;
}
.unanswered {
  background: #fff0f2;
  color: #dc0021;
}
.examFooter {
  position: initial;
}
</style>
<script>
import ft from "../Footer";
import headTop from "../Top";
import "../../../static/css/exam-content.css";
export default {
  data() {
    return {
      showContent: "",
      show: false,
      time: "",
      questionNum: "",
      examIndex: 0,
      tip: null,
      ifExamTakePhoto: "",
      ifLoseFocusAutoSubmitPaper: "",
      timer: "",
      platformId: "",
      captureTheTiming: "",
      imageUrl: "",
      dialogVisible: false,
      codeUrl: "",
      examinationId: "",
      showCodeTip: false,
      examIntervalId: "",
      scanIntervalId: "",
      uuid: "",
      windowindex: "",
      intervalId: 0,
      count: 0,
      examPaperList: {},
      questionTypeSummaries: [],
      questionList1: [],
      questionList2: [],
      questionList3: [],
      questionDescription: [],
      type: "001001",
      types: "001001",
      questonType: "",
      userHeadImagUrl: "",
      //考试时长 (分钟)
      duration: null,
      //考试剩余时间
      remainingTime: null,
      //考试开始时间
      startTime: 0,
      //考试结束时间
      endTime: 0,
      //当前时间
      currentTime: 0,
      laseExamList: [],
      type: "001001",
      types: "001001",
      realName: "",
      userHeadImagUrl: "",
      rightCountAll: 0, //正确值
      questionScores: [],
      questionTotals: {
        score: 0,
        totalScore: 0,
        questionCount: 0,
        totalQuestionCount: 0,
      },
      wrongQuestionLists: []
    };
  },
  methods: {
    //返回
    back() {
      this.$router.go(-1);
    },
    //切换题目
    selecteQuestion(index) {
      this.examIndex = index;
    },
    radioChange() {
      this.$forceUpdate();
    },
    //下一题
    nextQuestion() {
      if (this.examIndex + 2 > this.questionNum) {
        return false;
      } else {
        this.examIndex++;
      }
    },
    //上一题
    lastQuestion() {
      if (this.examIndex < 1) {
        return false;
      } else {
        this.examIndex--;
      }
    },
    //弹层
    showPopup() {
      this.show = !this.show;
    },
    examScoreData() {
      this.lastExamRecordId = this.$route.query.id;
      this.$axiosPackag.getMessageByAxios(
        "POST",
        "/api/student/onlineExam/viewRecord",
        { recordId: this.lastExamRecordId },
        null,
        null,
        (res) => {
          this.laseExamList = res;
          this.questionTypeSummaries = res.questionTypeSummaries;
          for (var i = 0; i < this.questionTypeSummaries.length; i++) {
            for (
              var j = 0;
              j < this.questionTypeSummaries[i].questions.length;
              j++
            ) {
              var question = this.questionTypeSummaries[i].questions[j];
              question.content = this.$util.html(question.content);
              question.analysis = this.$util.html(question.analysis);
              question.answer = this.$util.html(question.answer);
              if (question.choices) {
                for (var q = 0; q < question.choices.length; q++) {
                  question.choices[q].content = this.$util.html(
                    question.choices[q].content
                  );
                }
              }
              if (question.blanksNumber) {
                let blanksNumber = parseInt(question.blanksNumber);
                question.blanksNumbers = [];
                for (let f = 0; f < blanksNumber; f++) {
                  let op = {};
                  op.userAnswer = [];
                  question.blanksNumbers.push(op);
                }
              }
              if (question.type == "001001") {
                this.questionList1.push(question);
              } else if (question.type == "001002") {
                // debugger
                question.userAnswer = question.userAnswer
                  ? question.userAnswer.split(",")
                  : [];
                this.questionList2.push(question);
              } else if (question.type == "001003") {
                this.questionList3.push(question);
              }
              const a = this.questionList1;
              const b = this.questionList2;
              const c = this.questionList3;
              const d = [...a, ...b, ...c];
              this.questionLists = d;
              
              this.questionDescription[question.type] =
                this.questionTypeSummaries[i].description;
            }
          }
          this.questionLists.forEach((element) => {
                if (element.userScore == "0.0") {
                  this.wrongQuestionLists.push(element);
                }
              });
              this.questionNum = this.wrongQuestionLists.length;
          //初始化数据
          this.questionScores = [];
          this.questionTotals = {
            score: 0,
            totalScore: res.totalScore,
            questionCount: 0,
            totalQuestionCount: 0,
          };
          //答题汇总 对，错，未答，总分
          for (var i = 0; i < this.questionTypeSummaries.length; i++) {
            let questionScore = {
              // type: this.questionTypeSummaries[i].type,
              // title: this.questionTypeSummaries[i].description.split('，')[0],
              right: 0,
              error: 0,
              empty: 0,
              score: 0,
            };
            for (
              var j = 0;
              j < this.questionTypeSummaries[i].questions.length;
              j++
            ) {
              if (
                parseFloat(
                  this.questionTypeSummaries[i].questions[j].userScore
                ) > 0
              ) {
                questionScore.right++;
                questionScore.score += parseFloat(
                  this.questionTypeSummaries[i].questions[j].userScore
                );
                this.questionTotals.score += parseFloat(
                  this.questionTypeSummaries[i].questions[j].userScore
                );
                this.questionTotals.questionCount += 1;
              } else if (
                this.questionTypeSummaries[i].questions[j].userAnswer
              ) {
                questionScore.error++;
              } else {
                questionScore.empty++;
              }
              this.questionTotals.totalQuestionCount += 1;
              this.questionTypeSummaries[i].questions[j].content =
                this.$util.html(
                  this.questionTypeSummaries[i].questions[j].content
                );
              this.questionTypeSummaries[i].questions[j].analysis =
                this.$util.html(
                  this.questionTypeSummaries[i].questions[j].analysis
                );
              this.questionTypeSummaries[i].questions[j].answer =
                this.$util.html(
                  this.questionTypeSummaries[i].questions[j].answer
                );
              if (this.questionTypeSummaries[i].questions[j].choices) {
                for (
                  var q = 0;
                  q < this.questionTypeSummaries[i].questions[j].choices.length;
                  q++
                ) {
                  this.questionTypeSummaries[i].questions[j].choices[
                    q
                  ].content = this.$util.html(
                    this.questionTypeSummaries[i].questions[j].choices[q]
                      .content
                  );
                }
              }
            }
            this.questionScores.push(questionScore);
          }
        }
      );
    },
    menuBtn(type) {
      this.type = type;
    },
    menuBtns(types) {
      this.types = types;
    },
    returnBtn() {
      if (navigator.userAgent.indexOf("MSIE") > 0) {
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null;
          window.close();
        } else {
          window.open("", "_top");
          window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
        window.location.href = "about:blank ";
      } else {
        window.opener = null;
        window.open("", "_self", "");
        window.close();
      }
      //      this.$router.push({
      //        path: '/personal/myexam'
      //      });
    },
  },
  components: {
    headTop,
    ft,
  },
  mounted() {
    this.examScoreData();
  },
};
</script>



// WEBPACK FOOTER //
// MobileAnalysisWrongQuestions.vue?312b921a